import React from "react";

const AntdFormLabel = ({ label, className = "text-black/[.88] text-sm font-normal" }) => {
  return <div className={className}>{label}</div>;
};

export { AntdFormLabel };
